import uuid from "uuid/v1";

export const createOrderForPOS = (deviceID, table) => {
    const orderID = uuid();
    const posMessage = {} ;
    const posOrder = {
      BalanceGiven: 0,
      Coupons: [],
      BankCardsSurcharge: 0,
      BankCardsSurchargeExcludingTax: 0,
      BankCardsSurchargeTax: 0,
      Barcode: "",
      ContactCustomerContactNumber: "",
      ContactCustomerDisplayName: "",
      ContactCustomerEmailAddress: "",
      CustomerName: "",
      CreatedBy: 0,
      CreatedOn: new Date().toISOString(),
      CreatedOnStr: new Date().toISOString(),
      CustomerEmail: "",
      CustomerId: 0,
      CustomerMobile: "",
      Discount: 0,
      DiscountExcludingGst: 0,
      DiscountFlatValue: 0,
      DiscountGst: 0,
      DiscountPercentage: 0,
      DiscountedBy: 0,
      Freight: 0,
      GuestCount: 2,
      hasSentToMaster: false,
      ImageString: [],
      InvoiceNumber: "",
      isMasterPOSOrder: false,
      IsReceiptPrint: false,
      isSyncedToBackEnd: true,
      IsTotalExcludingTipAmount: true,
      Items: [],
      OrderConfirmedStatus: 1,
      OrderSourceType: 1,
      OrderType: 2,
      POSSurchargeExcludingTax: 0,
      POSSurchargeOfTax: 0,
      RedeemPoints: 0,
      RedeemedVouchers: [],
      ReferenceNumber: "",
      RefundBy: 0,
      RoundingExcludingTax: 0,
      SendMail: false,
      StaffName: "",
      Status: 8,
      Subtotal: 0,
      SubtotalExcludingTax: 0,
      SubtotalOfTax: 0,
      Surcharge: 0,
      SurchargeAmount: 0,
      SurchargeTransactions: [],
      Surcharges: [],
      Tables: [{ Name: table, Id: -1, Status: 2 }],      
      Timestamps: [
        {
          Type: 4,
          Time: new Date().toISOString(),
          TimestampUniqueCode: uuid(),
          OrderUniqueCode: orderID,
        },
      ],
      TipAmount: 0,
      TotalCost: 0,
      TotalExclTax: 0,
      TotalGst: 0,
      TotalPaid: 0,
      UniqueCode: orderID,
      UsedRewardPoint: false,
      Vouchers: [],
      IsSplitOrder: false,
      IsPartialPaidWithPortion: false,
    };
    posMessage.originDeviceId = deviceID;
    posMessage.server = {
      IPAddress: 'http://192.168.10.29:8080/',
      isAuthorized: 1,
      isConnected: 1,
      mode: 6,
    };
    posMessage.Order = posOrder;
    posMessage.shouldAddToRegister = true;
  
    return posMessage;
}
